export const number = {
    digitGroup(value) {
        if (!value) return value;

        // Formats numbers to have a dot (.) after every three digits
        // E.g. 10000 => 10.000, 1234567 => 1.234.567, 123 => 123, etc
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    },
};